import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatBadgeModule} from '@angular/material/badge';
import {MatRadioModule} from '@angular/material/radio';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {StringStrictPipe} from './pipes/string-strict.pipe';
import {RomanNumberPipe} from './pipes/roman-number.pipe';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {SanitizePipe} from './pipes/sanitize.pipe';
import {EmptyStateComponent} from './components/empty-state/empty-state.component';
import {ErrorStateComponent} from './components/error-state/error-state.component';
import {ListStringPipe} from './pipes/list-to-string.pipe';
import {dateTimezonePipe} from './pipes/dateTimezone';
import {StripTagsPipe} from './pipes/strip-tags.pipe';
import {MatInputModule} from '@angular/material/input';
import {MatTabsModule} from '@angular/material/tabs';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {FormControlExceptionDirective} from './directives/form-control-exception/form-control-exception';
import {CarregandoComponent} from './components/carregando/carregando.component';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';
import {GraficoIqarComponent} from './component/grafico-iqar/grafico-iqar.component';
import {GraficoPoluenteComponent} from './component/grafico-poluente/grafico-poluente.component';
import {TermoComponent} from '../login/termo/termo.component';
import {FiltrarUfComponent} from '../geral/filtrar-uf/filtrar-uf.component';
import {DetalheAtualizacaoComponent} from '../geral/detalhe-atualizacao/detalhe-atualizacao.component';
import {MatTableModule} from '@angular/material/table';
import {FlagsComponent} from '../flags/flags.component';
import {IniciaisPipe} from './pipes/iniciais.pipe';
import {ConfirmacaoValidacaoComponent} from '../gestao/confirmacao-validacao/confirmacao-validacao.component';
import {ModalValidarUsuarioPage} from './modals/modal-validar-usuario/modal-validar-usuario.page';
import {CpfCnpjPipe} from './pipes/cpf-cnpj.pipe';
import {NotEmptyPipe} from './pipes/not-empty.pipe';
import {TrocarSenhaComponent} from './modals/trocar-senha/trocar-senha.component';
import {ConvidarUsuarioComponent} from './modals/convidar-usuario/convidar-usuario.component';
import {IqarPipe} from './pipes/iqar.pipe';
import {ClimaPipe} from './pipes/clima.pipe';
import {ClimaComponent} from './component/clima/clima.component';
import {LegendaIqarComponent} from './component/legenda-iqar/legenda-iqar.component';
import {EstacaoFonteComponent} from '../estacoes/detalhe-estacao/estacao-fonte/estacao-fonte.component';
import {SelecionarPeriodoComponent} from './modals/selecionar-periodo/selecionar-periodo.component';
import {CalendarioModule} from './component/calendario/calendario.module';
import {NomePipe} from './pipes/resnome.pipe';
import {ModalAtualizacaoAppPage} from "./modals/modal-atualizacao-app/modal-atualizacao-app.page";
import {ModalStatusAppPage} from "./modals/modal-status-app/modal-status-app.page";

const MATERIAL = [
  MatProgressSpinnerModule,
  MatInputModule,
  MatNativeDateModule,
  MatDatepickerModule,
  MatFormFieldModule,
  MatAutocompleteModule,
  MatSelectModule,
  MatIconModule,
  MatRippleModule,
  MatCheckboxModule,
  MatBadgeModule,
  MatRadioModule,
  MatProgressBarModule,
  MatTabsModule,
  DragDropModule
];

@NgModule({
  declarations: [
    StringStrictPipe,
    RomanNumberPipe,
    SanitizePipe,
    EmptyStateComponent,
    ErrorStateComponent,
    ListStringPipe,
    dateTimezonePipe,
    StripTagsPipe,
    GraficoIqarComponent,
    GraficoPoluenteComponent,
    FormControlExceptionDirective,
    TermoComponent,
    FiltrarUfComponent,
    DetalheAtualizacaoComponent,
    CarregandoComponent,
    FlagsComponent,
    ModalValidarUsuarioPage,
    ConfirmacaoValidacaoComponent,
    IniciaisPipe,
    NomePipe,
    CpfCnpjPipe,
    NotEmptyPipe,
    TrocarSenhaComponent,
    ConvidarUsuarioComponent,
    ModalAtualizacaoAppPage,
    ModalStatusAppPage,
    IqarPipe,
    ClimaPipe,
    ClimaComponent,
    LegendaIqarComponent,
    EstacaoFonteComponent,
    SelecionarPeriodoComponent
  ],
  imports: [
    CommonModule,
    MATERIAL,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    VirtualScrollerModule,
    MatTableModule,
    CalendarioModule
  ],
  exports: [
    MATERIAL,
    StringStrictPipe,
    RomanNumberPipe,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    SanitizePipe,
    EmptyStateComponent,
    ErrorStateComponent,
    GraficoIqarComponent,
    GraficoPoluenteComponent,
    ListStringPipe,
    dateTimezonePipe,
    StripTagsPipe,
    FormControlExceptionDirective,
    TermoComponent,
    FiltrarUfComponent,
    DetalheAtualizacaoComponent,
    CarregandoComponent,
    IniciaisPipe,
    NomePipe,
    CpfCnpjPipe,
    NotEmptyPipe,
    IqarPipe,
    ClimaPipe,
    ClimaComponent,
    LegendaIqarComponent,
    EstacaoFonteComponent
  ]
})
export class SharedModule {
}
